var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _c("breadcrumb", {
        staticClass: "breadcrumb-container",
        attrs: { id: "breadcrumb-container" },
      }),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.device !== "mobile"
            ? [
                _c(
                  "span",
                  {
                    staticClass: "right-menu-item hover-effect",
                    staticStyle: { color: "cadetblue", "font-size": "12px" },
                  },
                  [_vm._v("Hi! " + _vm._s(_vm.name))]
                ),
                _c("error-log", {
                  staticClass: "errLog-container right-menu-item hover-effect",
                }),
                _c("screenfull", {
                  staticClass: "right-menu-item hover-effect",
                  attrs: { id: "screenfull" },
                }),
              ]
            : _vm._e(),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c(
                "div",
                { staticClass: "avatar-wrapper" },
                [
                  _vm.messageCount > 0 || _vm.faultBackCount > 0
                    ? _c(
                        "el-badge",
                        { staticClass: "item", attrs: { "is-dot": "" } },
                        [
                          _c("img", {
                            staticClass: "user-avatar",
                            attrs: {
                              src: _vm.avatar ? _vm.avatar : _vm.defaultAvatar,
                            },
                          }),
                          _c("i", { staticClass: "el-icon-caret-bottom" }),
                        ]
                      )
                    : _c("span", [
                        _c("img", {
                          staticClass: "user-avatar",
                          attrs: {
                            src: _vm.avatar ? _vm.avatar : _vm.defaultAvatar,
                          },
                        }),
                        _c("i", { staticClass: "el-icon-caret-bottom" }),
                      ]),
                ],
                1
              ),
              _c(
                "el-dropdown-menu",
                {
                  staticStyle: { padding: "5px 13px" },
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [_c("el-dropdown-item", [_vm._v("首頁")])],
                    1
                  ),
                  _c(
                    "router-link",
                    { attrs: { to: "/itaProfile/index" } },
                    [_c("el-dropdown-item", [_vm._v("個人資料")])],
                    1
                  ),
                  _c(
                    "router-link",
                    { attrs: { to: "/chat/index" } },
                    [
                      _vm.messageCount > 0
                        ? _c(
                            "el-badge",
                            {
                              staticClass: "item",
                              attrs: { value: _vm.messageCount },
                            },
                            [_c("el-dropdown-item", [_vm._v("即時訊息")])],
                            1
                          )
                        : _vm._e(),
                      _vm.messageCount == 0
                        ? _c("el-dropdown-item", [_vm._v("即時訊息")])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    { attrs: { to: "/educationResources/index" } },
                    [_c("el-dropdown-item", [_vm._v("教學資源")])],
                    1
                  ),
                  _c(
                    "router-link",
                    { attrs: { to: "/faultBack/index" } },
                    [
                      _vm.faultBackCount > 0
                        ? _c(
                            "el-badge",
                            {
                              staticClass: "item",
                              attrs: { value: _vm.faultBackCount },
                            },
                            [_c("el-dropdown-item", [_vm._v("故障與回饋")])],
                            1
                          )
                        : _vm._e(),
                      _vm.faultBackCount == 0
                        ? _c("el-dropdown-item", [_vm._v("故障與回饋")])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout($event)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { display: "block" } }, [
                        _vm._v("登出"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }